import axios from "axios";


const API = axios.create({

baseURL: `${process.env.REACT_APP_BACKEND_URI}/api`

});


export const getPriorities = async()=>{

const response = await API.get("/priorities/");

return response.data;

};